import React, { useEffect } from "react";
import { Checkbox } from "@progress/kendo-react-inputs";

/**
 * Multi-select checkboxes renderer component
 * @param {Object} props - Component props
 * @param {Array} props.options - Array of option objects with label and value
 * @param {Array} props.selectedValue - Currently selected values
 * @param {Function} props.onOptionClick - Handler for option selection
 * @param {boolean} props.required - Whether the field is required
 * @returns {JSX.Element} Multi-select checkboxes component
 * @author Abhishek Dhillon
 */
const MultiSelectCheckboxes = ({ options, selectedValue, onOptionClick, required, showResponses }) => {
  useEffect(() => {
    if (selectedValue && onOptionClick) {
      onOptionClick(selectedValue);
    }
  }, []);
  return (
    <div className='d-flex'>
      <div className='option-checkboxes-container d-flex flex-column border w-100 p-2'>
        {options.map((option, index) => {
          const isSelected = Array.isArray(selectedValue) ? selectedValue.includes(option.value) : false;
          return (
            <div key={index} className={`option-checkbox-item ${isSelected ? "selected" : ""}`}>
              <div className='option-checkbox-wrapper'>
                <Checkbox
                  size='medium'
                  checked={isSelected}
                  onChange={() => onOptionClick(option.value)}
                  label={option.label}
                  disabled={showResponses}
                />
              </div>
            </div>
          );
        })}
      </div>
      {required && <span className='required-asterisk text-danger ms-1 ml-1'>*</span>}
    </div>
  );
};

export default MultiSelectCheckboxes;
